/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React, { useContext,useEffect,useState } from 'react'
import { FormContext } from '../Component/Forms/FormContext';
import OutlinedInput from '@mui/material/OutlinedInput';
import {InputLabel} from '@material-ui/core';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import moment from 'moment';
import ThemeControls from "../Component/AllThemesControl";
//validation 
import elementValidation from '../Component/validation';

export default function TimePicker(props) {
  const {field_type, field_id, field_label, field_placeholder,field_mandatory, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq } = props;
  const { handleChange } = useContext(FormContext)
  const {useStyle} = ThemeControls;
  const classes = useStyle(); 
  // Convert initial value to 24-hour format
  const initialTime = field_value ? moment(field_value, 'HH:mm:ss').format('hh:mm:ss a') : '00:00';

  const [value, setValue] = useState(initialTime);
  const elementField = {field_type, field_id, field_label, field_placeholder, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,field_mandatory };
  function handleBlur(){
    // //console.log(field_value)
    elementValidation(elementField)
    
  }
  
  useEffect(() => {
    setValue(initialTime);
    const formattedTime = moment(initialTime, 'HH:mm:ss').format('hh:mm:ss a');
    handleChange(field_id, {}, formattedTime);
  }, [])

  const handleTimeChange = (event) => {
    const timeValue = event.target.value;
    console.log(timeValue)
    const formattedTime = moment(timeValue, 'HH:mm:ss').format('hh:mm:ss a');
    setValue(timeValue);
    handleChange(field_id, {}, formattedTime);
  };

  return (

    <div className={classes.inputroot}>
    <div style={{display:"flex"}}>
    <InputLabel className={classes.label}>{field_label}</InputLabel>{field_mandatory==="yes"?<span 
    style={{fontSize: "18px",
    color: "#d71729",
    fontWeight: "400",
    lineHeight: "20px",
    transform: "translateY(-2px)"}}>*</span>:null}
    </div>
     <FormControl className={classes.border}>
      <OutlinedInput className={classes.input}
        id={field_id}
        // type={field_type}
        type='time'
        defaultValue=""
        value={value}
        onBlur={handleBlur}
        onChange={handleTimeChange}
      />
      {/* <span>(HH/MM)</span> */}
       <FormHelperText>{field_helperText||elementField.field_helperText}</FormHelperText>
      </FormControl>
    </div>
  );
}
